/* -------------------------------------------------------------------------- */
/*                                    页面权限                                 */
/* -------------------------------------------------------------------------- */

export const ROLE_PAGE_UUID = '06cff318-8909-4ab9-8238-39ccf2c5bed8'

/* -------------------------------------------------------------------------- */
/*                                    操作权限                                 */
/* -------------------------------------------------------------------------- */

// 管理角色
export const ROLE_ACTION_UUID = '17f520c0-0279-4686-ad8d-930ea8cfecba'
